const importMetaEnv = typeof import.meta === "object"
  && import.meta
  && typeof import.meta.env === "object"
  && import.meta.env
  ? import.meta.env
  : {};

const RESET_PASSWORD_PATH = "/reset-password";

function normalizeOrigin(value) {
  const resolvedValue = String(value || "").trim();
  if (!resolvedValue) {
    return "";
  }

  return resolvedValue.replace(/\/+$/, "");
}

export function resolvePasswordResetRedirectUrl() {
  const configuredOrigin = normalizeOrigin(importMetaEnv.VITE_PUBLIC_APP_URL);
  if (configuredOrigin) {
    return `${configuredOrigin}${RESET_PASSWORD_PATH}`;
  }

  if (typeof window === "undefined" || !window.location?.origin) {
    return RESET_PASSWORD_PATH;
  }

  return new URL(RESET_PASSWORD_PATH, window.location.origin).toString();
}

function parseHashParams(hashValue) {
  const normalizedHash = String(hashValue || "").trim();
  if (!normalizedHash) {
    return null;
  }

  const rawHash = normalizedHash.startsWith("#")
    ? normalizedHash.slice(1)
    : normalizedHash;
  if (!rawHash) {
    return null;
  }

  return new URLSearchParams(rawHash);
}

export function redirectSupabaseRecoveryHashIfNeeded() {
  if (typeof window === "undefined") {
    return false;
  }

  const hashParams = parseHashParams(window.location.hash);
  if (!hashParams?.get("access_token")) {
    return false;
  }

  const recoveryType = hashParams.get("type");
  if (recoveryType && recoveryType !== "recovery") {
    return false;
  }

  const currentPath = window.location.pathname.replace(/\/+$/, "") || "/";
  const resetPasswordPath = RESET_PASSWORD_PATH;
  if (currentPath === resetPasswordPath || currentPath.endsWith(resetPasswordPath)) {
    return false;
  }

  const nextUrl = `${resetPasswordPath}${window.location.search || ""}${window.location.hash || ""}`;
  window.location.replace(nextUrl);
  return true;
}
